
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"path-1",attrs:{"fill":"#000","fill-rule":"evenodd","d":"M16.64 11.57h-3.2V8.36a.36.36 0 00-.36-.36h-2.15a.36.36 0 00-.36.36v3.21h-3.2a.36.36 0 00-.37.34v2.15a.36.36 0 00.36.37h3.21v3.21a.36.36 0 00.36.36h2.15a.36.36 0 00.35-.36v-3.21h3.21a.36.36 0 00.36-.36v-2.14a.36.36 0 00-.36-.36zm-.34 2.14h-3.22a.36.36 0 00-.36.36v3.22h-1.43v-3.22a.36.36 0 00-.36-.36H7.71V12.3h3.22a.36.36 0 00.36-.36V8.7h1.43v3.22a.36.36 0 00.36.36h3.22v1.42z","clip-rule":"evenodd"}}),_c('path',{staticClass:"path-2",attrs:{"fill":"#000","fill-rule":"evenodd","d":"M21.64 5.16h-2.5V4.8c0-.1-.03-.19-.1-.25a.36.36 0 00-.25-.11h-.72a.36.36 0 00-.36.36v.36H6.3V4.8a.36.36 0 00-.36-.36H5.2a.36.36 0 00-.35.36v.36h-2.5a.36.36 0 00-.36.36v15.12c0 .1.04.19.1.25.07.07.16.11.26.11h19.28a.36.36 0 00.36-.36V5.52a.36.36 0 00-.36-.36zm-.35 15.12H2.7V5.88h18.6v14.4zM10.57 3a1.43 1.43 0 00-1.43 1.44.36.36 0 00.36.36.36.36 0 00.36-.36.72.72 0 01.71-.72h2.86c.19 0 .37.08.5.21.14.14.21.32.21.51a.36.36 0 00.36.36c.1 0 .19-.04.25-.1.07-.07.1-.16.1-.26A1.45 1.45 0 0013.44 3h-2.86z","clip-rule":"evenodd"}})])
          )
        }
      }
    